import {
  Component,
  forwardRef,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, FormGroup } from '@angular/forms';

@Component({
  selector: 'taly-custom-input',
  templateUrl: './custom-input.component.html',
  styleUrls: ['./custom-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomInputComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => CustomInputComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CustomInputComponent implements ControlValueAccessor {
  private changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);
  @Input({ required: true }) id: string = '';
  @Input({ required: true }) label: string = '';
  @Input() placeholderText?: string = '';
  @Input() inputType?: any = 'input';
  @Input() formGroup!: FormGroup;
  @Input() controlName!: string;
  @Input() min!: number;
  @Input() max!: number;
  @Input() inputmodeType: string = 'none';

  @Input() set isDisabled(disable: boolean) {
    this.disabled = disable;
  }

  disabled = false;

  get f() {
    return this.formGroup?.controls;
  }

  constructor() {}

  private _value: any | null = null;

  set value(value: any) {
    this._value = value;
    this.onChange();
  }

  get value(): any {
    return this._value;
  }

  onChange() {}

  onReset() {
    if (this.formGroup && this.controlName) {
      this.formGroup.get(this.controlName)?.setValue(null); // Set the value in the form control
    }
  }

  onTouched = () => {};

  writeValue(value: any) {
    this.value = value;
    if (this.changeDetectorRef) {
      this.changeDetectorRef.markForCheck();
    }
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  // Implement the validator function
  validate() {
    return null;
  }
}
